// extracted by mini-css-extract-plugin
module.exports = {"TabSection":"TabSection_TabSection__CDS5u"};